import { render, staticRenderFns } from "./qianyue.vue?vue&type=template&id=2492f7ba&"
import script from "./qianyue.vue?vue&type=script&lang=ts&"
export * from "./qianyue.vue?vue&type=script&lang=ts&"
import style0 from "./qianyue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports